import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProjectPerformanceReview } from '../../shared/models/pprs/project-performance-review.model';
import { ReviewsSearch } from '../../shared/models/reviews/reviews-search.model';
import { Paging } from '../../shared/models/paging/paging.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ReviewService {
  private baseUrl = environment.baseUrl + 'v2.0/projects/reviews/';

  constructor(private http: HttpClient) { }

  public getReview = (id: string) => this.http.get<ProjectPerformanceReview>(`${this.baseUrl}${id}`);

  public getReviews = (dto: ReviewsSearch, page: number, pageSize: number) => {
    dto = this.adjustDates(dto);
    var url = `${this.baseUrl}search?page=${page}&pagesize=${pageSize}`;
    if (dto.projectId != '') {
      url = `${url}&projectid=${dto.projectId}`;
    }

    if (dto.companyNumber != '') {
      url = `${url}&companynumber=${dto.companyNumber}`;
    }

    if (dto.startDate != '') {
      url = `${url}&startdate=${dto.startDate}`;
    }

    if (dto.endDate != '') {
      url = `${url}&enddate=${dto.endDate}`;
    }

    if (dto.status != '') {
      url = `${url}&status=${dto.status}`;
    }

    if (dto.projectName != '') {
      url = `${url}&projectname=${dto.projectName}`;
    }

    return this.http.get<Paging<ProjectPerformanceReview>>(url);
  }

  public setReview = (id: string, data: ProjectPerformanceReview) => this.http.patch<ProjectPerformanceReview>(`${this.baseUrl}${id}`, data);

  private adjustDates = (dto: ReviewsSearch) => {
    dto.startDate = this.adjustDate(dto.startDate);
    dto.endDate = this.adjustDate(dto.endDate);

    if (dto.startDate == '') return dto;
    if (dto.endDate == '') return dto;

    var startDate = new Date(dto.startDate);
    var endDate = new Date(dto.endDate);
    if (startDate <= endDate) {
      return dto;
    }

    // Switch the start and end dates
    var startTemp = startDate;
    startDate = endDate;
    endDate = startTemp;

    dto.startDate = startDate.toJSON() ?? '';
    dto.endDate = endDate.toJSON() ?? '';
    return dto;
  }

  private adjustDate = (dateString: string) => {
    dateString ??= '';
    if (dateString == '') return dateString;

    var date = new Date(dateString);
    return date.toJSON() ?? '';
  }
}
